module.exports = __webpack_public_path__ + "static/media/monster3.6bfc6521.png";